import Intercom, { boot, shutdown, update } from '@intercom/messenger-js-sdk'
import { deleteCookie } from '@/plugins/cookie-cleanup'

const APP_ID = 'd7m131ho'

// Identity is only sent with a backend-signed JWT, so nobody can claim another user's id from the console.
const toSettings = user => {
	if (!user?.intercom_jwt) return { app_id: APP_ID }

	const name =
		`${user.firstname || ''} ${user.lastname || ''}`.trim() || user.name
	const createdAt = Math.floor(new Date(user.created_at).getTime() / 1000)
	return {
		app_id: APP_ID,
		intercom_user_jwt: user.intercom_jwt,
		user_id: user.intercom_user_id,
		email: user.email,
		...(name && { name }),
		...(Number.isFinite(createdAt) && { created_at: createdAt })
	}
}

const hasUnexpiredToken = token => {
	try {
		const payload = token
			.split('.')[1]
			.replace(/-/g, '+')
			.replace(/_/g, '/')
		const { exp } = JSON.parse(atob(payload))
		return Number.isFinite(exp) && exp > Date.now() / 1000
	} catch {
		return false
	}
}

export default function({ store, $config }) {
	let currentUser = store.state.user.user
	Intercom(toSettings(currentUser))

	const identity = user => [user?.id, toSettings(user).user_id].join()
	store.watch(
		state =>
			[
				state.user.user?.id,
				state.user.user?.intercom_user_id,
				state.user.user?.intercom_jwt
			].join(),
		() => {
			const user = store.state.user.user
			const previousUser = currentUser
			const sameIdentity = identity(user) === identity(previousUser)
			currentUser = user

			// An expired cached JWT can reject the initial boot; update cannot recover that session.
			if (sameIdentity && hasUnexpiredToken(previousUser?.intercom_jwt)) {
				return update(toSettings(user))
			}

			shutdown()
			if (
				previousUser?.id != null &&
				(previousUser.id !== user?.id ||
					(previousUser.intercom_jwt && !sameIdentity))
			) {
				// Shutdown can leave anonymous identity cookies behind and merge another person's conversations.
				document.cookie
					.split(';')
					.map(cookie => cookie.trim().split('=')[0])
					.filter(name => name.startsWith('intercom-'))
					.forEach(name => deleteCookie(name, $config))
			}
			boot(toSettings(user))
		}
	)
}
